import { CommonModule } from "@angular/common";
import { DatastoreSeoNavbarModule } from "@topyourthree/datastore/collections";
import { PipesModule } from "@topyourthree/pipes";
import { UiModule } from "@topyourthree/ui";
import { ThemeButtonModule } from "./theme-button/theme-button.module";
import * as i0 from "@angular/core";
export class SeoNavbarModule {
}
SeoNavbarModule.ɵfac = function SeoNavbarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SeoNavbarModule)(); };
SeoNavbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SeoNavbarModule });
SeoNavbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ThemeButtonModule,
        DatastoreSeoNavbarModule,
        PipesModule,
        UiModule] });
